import {isUnidentifiedRecipient} from 'shells/inbox/helpers';

import type {OriginType} from 'nutshell-graphql-types';
import type {LeadCreateInput} from 'nutshell-graphql-types';

import {AUTO_DISTRIBUTE_OPTION} from '../../core/form/fields/consts';

import {useCreateLead} from '../graphql/hooks/use-create-lead';
import {notifyUser} from '../helpers';

import {BaseAddLeadButton} from './base-add-lead-button';

interface Props {
    recipientId: string;
    threadId: string;
    origin: OriginType;
    stagesetId: string;
    assigneeId?: string | null;
}

export function AddLeadFromContactButton(props: Props) {
    const {createLead} = useCreateLead();

    if (isUnidentifiedRecipient(props.recipientId)) {
        return null;
    }

    const handleSubmit = async () => {
        const input: LeadCreateInput = {
            contacts: [props.recipientId],
            stageset: props.stagesetId === AUTO_DISTRIBUTE_OPTION.value ? null : props.stagesetId,
            assignee: props.assigneeId,
            origin: props.origin,
        };

        const response = await createLead(input, props.threadId);
        if (response?.data?.leadCreate?.htmlUrlPath) {
            notifyUser(response.data.leadCreate.htmlUrlPath);
        }
    };

    return (
        <BaseAddLeadButton
            onSubmit={handleSubmit}
            errorMessage='An error occurred while saving. Please try again later.'
        />
    );
}
